import type { IGetActionsData } from "@api";

export interface IActionPopoverState {
  anchorEl?: HTMLElement;
  actions?: IGetActionsData[];
}

export enum ActionCardTitleDisplay {
  ACTION = "action",
  ACTION_COMPACT = "actionCompact",
  CHALLENGE = "challenge",
}
